import { SerializedError } from '@reduxjs/toolkit';
import { Song } from 'src/@types/api-types';

import { SCOPE } from 'shared-types/constants';
import { Lyrics } from 'shared-types/lyrics';
import { VideoMetadata } from 'shared-types/video-metadata';
import { SwipeColors } from 'types/swipeColors';

export enum RequestState {
  loading = 0,
  error = 1,
  success = 2,
}

export type RequestData<Value = undefined> =
  | { state: RequestState.loading }
  | { state: RequestState.success; value: Value }
  | { state: RequestState.error; error: SerializedError };

export type VideoPlayerResourcesState = {
  songDetails: RequestData<Song>;
  background: RequestData;
  videoMetadata: RequestData<VideoMetadata>;
  swipeColors: RequestData<SwipeColors>;
  lyrics: RequestData<Lyrics>;
  instrumental: RequestData;
  vocalGuide: RequestData;
  fadeDuration: number;
};

export interface FetchSongPayload {
  songId: string;
  scope: SCOPE;
  userId: string;
  isStorageActivated: boolean;
}

export interface FetchWaitingListSongsMetadata {
  waintingList: Song[];
}
